// src/utils/insertBox.js
// Single insert path for public.boxes.
//
// The BEFORE INSERT trigger trg_assign_box_sequence owns display_sequence and
// global_package_id: it assigns both under a per-manifest advisory lock and
// overwrites anything the client sends. So the client never sends them, and
// always reads the real values back from the inserted row.
//
// boxes_manifest_sequence_uniq and boxes_global_package_id_uniq turn a
// collision into a 23505 instead of a silent duplicate. On 23505 we retry the
// insert exactly once (with a fresh box_id when the caller can make one, in
// case the collision was on the primary key); a second failure surfaces a
// Spanish message and stops — no loop.

export const BOX_NUMBER_ERROR = 'No se pudo asignar el número de caja. Intenta de nuevo.';

const UNIQUE_VIOLATION = '23505';

/**
 * @param client       supabase client (or the mock's fake client)
 * @param payload      the boxes row; display_sequence / global_package_id are dropped
 * @param regenerateId optional () => new box_id, used for the single retry
 * @returns the inserted row (box_id, display_sequence, global_package_id, ...)
 */
export async function insertBox(client, payload, { regenerateId } = {}) {
  // eslint-disable-next-line no-unused-vars
  const { display_sequence, global_package_id, ...row } = payload;

  const attempt = (data) => client.from('boxes').insert([data]).select().single();

  let { data, error } = await attempt(row);
  if (error?.code === UNIQUE_VIOLATION) {
    console.warn('[insertBox] 23505 on insert, retrying once:', error.message);
    const retryRow = regenerateId ? { ...row, box_id: regenerateId() } : row;
    ({ data, error } = await attempt(retryRow));
    if (error?.code === UNIQUE_VIOLATION) {
      console.error('[insertBox] 23505 again after retry:', error);
      const err = new Error(BOX_NUMBER_ERROR);
      err.code = UNIQUE_VIOLATION;
      err.detail = error.message;
      err.__es = true; // agency adapter's guard() passes Spanish errors through untouched
      throw err;
    }
  }
  if (error) throw error;
  return data;
}
